import { useCallback, useState, type ReactNode } from 'react';
import { ConfirmDialog } from './ConfirmDialog';

type Ask = {
  title: string;
  body: ReactNode;
  /** מה הכפתור עושה, בלשון הפעולה */
  confirmLabel: string;
  tone?: 'bad' | 'warn';
  onConfirm: () => void;
};

/**
 * שאלה לפני פעולה שאי אפשר לבטל אחריה.
 *
 * מרכז את ה state של הדיאלוג כדי שבכל מסך זו תהיה שורה אחת: `ask`
 * בלחיצה, ו `dialog` בסוף ה JSX.
 *
 * לא לכל מחיקה. שורה בודדת מקבלת חלון חרטה (useUndo), כי שאלה
 * שנשאלת בכל פעם נלחצת בלי קריאה. כאן נשארות שתי משפחות: פעולה
 * שמוחקת נתונים שאנשים אחרים יצרו, ופעולה שיוצאת החוצה לאנשים.
 */
export function useConfirm() {
  const [pending, setPending] = useState<Ask | null>(null);

  const ask = useCallback((input: Ask) => setPending(input), []);

  const dialog = pending ? (
    <ConfirmDialog
      title={pending.title}
      body={pending.body}
      confirmLabel={pending.confirmLabel}
      tone={pending.tone}
      onConfirm={() => {
        pending.onConfirm();
        setPending(null);
      }}
      onCancel={() => setPending(null)}
    />
  ) : null;

  return { ask, dialog };
}
